import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Activity, RotateCcw } from 'lucide-react'

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }
  static getDerivedStateFromError(error: Error) { return { error } }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('iMed UI error', error, info) }
  render() {
    if (!this.state.error) return this.props.children
    return <main className="fatal-screen"><div className="fatal-card"><span className="brand-mark"><Activity /></span><p className="eyebrow">iMed recovery</p><h1>Something interrupted this screen.</h1><p>Your saved study data is safe. Reload iMed to continue.</p><button className="button primary" onClick={() => location.reload()}><RotateCcw size={17} /> Reload application</button><details><summary>Technical details</summary><pre>{this.state.error.message}</pre></details></div></main>
  }
}
